import React, { useState } from 'react';
import Upcoming from "../../../Components/Common/Upcoming";
import IntgnConfig from "./IntgnConfig";
import Policies from "../Policies/Policies";
import MetaLeadImport from "../../Threads/Integrations/MetaLeadImport";
import { isLive } from '../../../Utils/Utilities';
import useIsMobile from '../../../Hooks/useIsMobile';
import { getAgencyDetails } from '../../../Store/Reducers';
import { useSelector } from 'react-redux';
import { cn } from '../../../Lib/Cn'
import { SHOW_IMPORT_INQUIRIES, canShowImportInquiries } from '../../../Utils/FeatureFlags';


import { Card, CardContent } from '../../../Components/UI/card';

const integrationData = [
  { id: 1, name: "indiaMart", image: isLive() ? "/Web/assets/Images/Integrations/indiamart.png" : "/assets/Images/Integrations/indiamart.png", alt: "Indiamart", description: "Connect with IndiaMART B2B marketplace" },
  { id: 2, name: "justDial", image: isLive() ? "/Web/assets/Images/Integrations/justdial.png" : "/assets/Images/Integrations/justdial.png", alt: "Justdial", description: "Sync with JustDial business directory" },
  { id: 3, name: "tradeIndia", image: isLive() ? "/Web/assets/Images/Integrations/tradeindia.png" : "/assets/Images/Integrations/tradeindia.png", alt: "TradeIndia", description: "Integrate with TradeIndia platform" },
  { id: 4, name: "meta", image: isLive() ? "/Web/assets/Images/Integrations/meta.png" : "/assets/Images/Integrations/meta.png", alt: "Meta", description: "Connect Meta business accounts" },
  // { id: 5, name: "whatsapp", image: isLive() ? "/Web/assets/Images/Integrations/whatsapp.png" : "/assets/Images/Integrations/whatsapp.png", alt: "WhatsApp", description: "Integrate your WhatsApp account" },
  // { id: 6, name: "housing", image: isLive() ? "/Web/assets/Images/Integrations/housing.png" : "/assets/Images/Integrations/housing.png", alt: "Housing" },
  // { id: 7, name: "99Acres", image: isLive() ? "/Web/assets/Images/Integrations/99acres.png" : "/assets/Images/Integrations/99acres.png", alt: "99Acres" },
  // { id: 8, name: "magicBricks", image: isLive() ? "/Web/assets/Images/Integrations/magicbricks.png" : "/assets/Images/Integrations/magicbricks.png", alt: "MagicBricks" },
  // { id: 9, name: "w3", image: isLive() ? "/Web/assets/Images/Integrations/w3.png" : "/assets/Images/Integrations/w3.png", alt: "W3", description: "Sync your website with W3" },
  { id: 10, name: "email", image: isLive() ? "/Web/assets/Images/Integrations/email.png" : "/assets/Images/Integrations/email.png", alt: "Email", type: "policy", description: "Configure email policies" },
  { id: 11, name: "googleReview", image: isLive() ? "/Web/assets/Images/Integrations/google_review.png" : "/assets/Images/Integrations/google_review.png", alt: "Google Review", type: "policy", description: "Manage Google Review links" },
];


export default function IntegrationsPage() {
  const [upcomingOpen, setUpcomingOpen] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configIntegration, setConfigIntegration] = useState({ name: "", isWeb: false });
  const [policyOpen, setPolicyOpen] = useState(false);
  const [policyType, setPolicyType] = useState("");
  const [metaImportOpen, setMetaImportOpen] = useState(false);
  const isMobile = useIsMobile();
  const agencyData = useSelector(getAgencyDetails);
  
	let finalIntegrations = [
		...integrationData,
		...(agencyData?.IsWabaAgn
			? [{
			id: 5,
			name: "whatsapp",
			image: isLive()
			? "/Web/assets/Images/Integrations/whatsapp.png"
			: "/assets/Images/Integrations/whatsapp.png",
			alt: "WhatsApp",
			description: "Integrate your WhatsApp account",
		}]
		: []),
	];

	if (!canShowImportInquiries()) {
		finalIntegrations = finalIntegrations.filter(
			item => !["indiaMart", "justDial", "tradeIndia", "meta"].includes(item.name)
		);
	}


  const handleCardClick = (card) => {
    // Handle policy type integrations (Email and Google Review)
    if (card.type === "policy") {
      if (card.name === "email") {
        setPolicyType("EMAIL");
      } else if (card.name === "googleReview") {
        setPolicyType("GOOGLE_REVIEW_LINK");
      }
      setPolicyOpen(true);
    } else if (card.name === "meta") {
      setMetaImportOpen(true);
    } else if ([6, 7, 8, 9].includes(card.id)) {
      setUpcomingOpen(true);
    } else {
      setConfigIntegration({ name: card.name, isWeb: false });
      setConfigOpen(true);
    }
  };
 
  return (
    <>
      <div className={cn(
        "grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 w-full",
        isMobile ? "px-1 pt-4 pb-20" : "" 
      )}>
        {finalIntegrations.map(card => (
          <Card
            key={card.id}
            onClick={() => handleCardClick(card)}
            className="sahi-card !shadow-[0_2px_6px_rgba(0,0,0,0.04)] !rounded-xl !pb-3 cursor-pointer py-3 flex flex-col overflow-visible !h-full"
          >
            <CardContent className="sahi-card-content flex items-center justify-center py-3">
              <img
                src={card.image}
                alt={card.alt}
                className={`object-contain mx-auto ${["MagicBricks", "Website"].includes(card.name)
                  ? "h-16 sm:h-20"
                  : "h-12 sm:h-14"
                  }`}
              />
            </CardContent>
            {card.description && (
              <p className="hidden sm:block text-center text-sm text-zinc-500 px-2 leading-relaxed">{card.description}</p>
            )}
          </Card>
        ))}
      </div>
      <Upcoming open={upcomingOpen} onOpenChange={setUpcomingOpen} />
      {configOpen && (
        <IntgnConfig
          intgnName={configIntegration.name}
          isWebEdit={configIntegration.isWeb}
          onClose={() => setConfigOpen(false)}
        />
      )}
      {policyOpen && (
        <Policies
          open={policyOpen}
          onOpenChange={setPolicyOpen}
          configType={policyType}
        />
      )}
      <MetaLeadImport
        open={metaImportOpen}
        onOpenChange={setMetaImportOpen}
      />
    </>
  );
}